<template>
  <el-dialog
    class="update-password-dialog common-dialog"
    title="修改密码"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :append-to-body="true"
    @close="closeDialog"
  >
    <el-form
      ref="editForm"
      :model="editForm"
      :rules="rules"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-ruleForm"
    >
      <el-form-item label="旧密码" prop="oldPassword">
        <el-input
          v-model.trim="editForm.oldPassword"
          type="password"
          :maxlength="20"
          autocomplete="off"
          placeholder="请输入旧密码"
        ></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="password">
        <el-input
          v-model.trim="editForm.password"
          type="password"
          :maxlength="20"
          autocomplete="off"
          placeholder="请输入新密码"
          @change="handlePwChange"
        ></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="newPassword">
        <el-input
          v-model.trim="editForm.newPassword"
          type="password"
          :maxlength="20"
          autocomplete="off"
          placeholder="请再次输入新密码"
          @change="handlePwChange"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" class="dialogButtonB" @click="submitForm('editForm')">
        确定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import adaptation from '@/mixins/adaptation'
import { handleEncrpty } from '@/utils/sm4Func'
export default {
  name: 'UpdatePasswoord',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 80
  },
  props: {},
  data() {
    // 新密码复杂度验证：大写字母、小写字母、数字、特殊字符中三种组合，长度为8-20位
    const validatePasswordComplexity = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入新密码'))
        return
      }

      // 检查长度
      if (value.length < 8 || value.length > 20) {
        callback(new Error('密码长度为8-20位'))
        return
      }

      // 检查是否与用户名相同或包含用户名
      if (this.userName && value.toLowerCase() === this.userName.toLowerCase()) {
        callback(new Error('密码不能与用户名相同'))
        return
      }
      if (this.userName && value.toLowerCase().includes(this.userName.toLowerCase())) {
        callback(new Error('密码不能包含用户名'))
        return
      }

      // 检查是否与旧密码相同
      if (this.editForm.oldPassword && value === this.editForm.oldPassword) {
        callback(new Error('新旧密码不能一致'))
        return
      }

      // 检查复杂度：大写字母、小写字母、数字、特殊字符中至少三种组合
      let hasUpperCase = /[A-Z]/.test(value)
      let hasLowerCase = /[a-z]/.test(value)
      let hasNumber = /[0-9]/.test(value)
      let hasSpecialChar = /[^A-Za-z0-9]/.test(value)

      let complexityCount = 0
      if (hasUpperCase) complexityCount++
      if (hasLowerCase) complexityCount++
      if (hasNumber) complexityCount++
      if (hasSpecialChar) complexityCount++

      if (complexityCount < 3) {
        callback(new Error('密码必须包含大写字母、小写字母、数字、特殊字符中的三种组合'))
        return
      }

      callback()
    }

    // 确认密码验证：必须与新密码一致
    const validateConfirmPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入确认密码'))
        return
      }
      if (value !== this.editForm.password) {
        callback(new Error('确认密码必须与新密码一致'))
        return
      }
      callback()
    }
    return {
      dialogVisible: false,
      editForm: {
        newPassword: '',
        oldPassword: '',
        password: ''
      },
      rules: {
        password: [
          { required: true, validator: validatePasswordComplexity, trigger: 'blur' }
        ],
        oldPassword: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
        newPassword: [
          { required: true, validator: validateConfirmPassword, trigger: 'blur' }
        ]
      },
      adaptationVars: {
        formLabelWidth: 80
      }
    }
  },
  computed: {
    ...mapState({
      userName: index => {
        return (
          index.app.userInfo.username || ''
        )
      }
    }),
  },
  watch: {
    // 当用户名变化时，重新验证新密码字段
    userName() {
      if (this.$refs.editForm) {
        // 如果新密码字段有值，重新验证
        if (this.editForm.password) {
          this.$refs.editForm.validateField('password')
        }
      }
    },
    // 当旧密码变化时，重新验证新密码字段（检查新旧密码是否一致）
    'editForm.oldPassword'() {
      if (this.$refs.editForm) {
        // 如果新密码字段有值，重新验证
        if (this.editForm.password) {
          this.$refs.editForm.validateField('password')
        }
      }
    },
    // 当新密码变化时，重新验证确认密码字段
    'editForm.password'() {
      if (this.$refs.editForm) {
        // 如果确认密码字段有值，重新验证
        if (this.editForm.newPassword) {
          this.$refs.editForm.validateField('newPassword')
        }
      }
    }
  },
  methods: {
    handleOpen() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.$refs['editForm'].resetFields()
      this.dialogVisible = false
    },
    submitForm(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          let params = {
            newPassword: handleEncrpty(this.editForm.newPassword),
            oldPassword: handleEncrpty(this.editForm.oldPassword)
          }
          this.$apis.system.changePwd(params).then(res => {
            if (res) {
              this.$message({
                type: 'success',
                message: '密码修改成功,请重新登录！请于密码有效期前再次修改密码'
              })
              this.dialogVisible = false
            }
          })
        } else {
          return false
        }
      })
    },
    handlePwChange() {
      this.$refs.editForm.validateField('password')
      this.$refs.editForm.validateField('newPassword')
    },
    handleCancel() {
      this.editForm.newPassword = ''
      this.editForm.oldPassword = ''
      this.editForm.password = ''
      this.dialogVisible = false
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('update-password-dialog', (), ());
.update-password-dialog.common-dialog {
  @include adaptation(());
  /deep/ .el-dialog {
    width: var(--common-dialog-width);
  }
}
</style>
